



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import { BillingType, MeasuringStatesClient, ListForFollowUpQuery, DataSourceLoadOptionsBase, PeriodType, SetMultipleQualityCheckedCommand } from '@/data/web-api-client';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import dxDataGrid from 'devextreme/ui/data_grid';
import employeesRepository from '@/modules/employees/employeesRepository';

@Component({
  components: {
    Card,
    Datagrid,
  },
})
export default class FollowUpOverview extends Vue {
  loading = false;

  billingType: TypeOrNull<BillingType> = null;
  billingTypeEnum = BillingType;

  periodType: PeriodType = PeriodType.ExcludingCurrentMonth;
  periodTypeEnum = PeriodType;

  totalCount = 0;
  employees: any[] = [];
  executeBtnDisabled = true;

  private measuringStatesClient = new MeasuringStatesClient(undefined, this.$axios);

  async mounted() {
    await this.loadEmployees();
  }

  public openDetails(e: any) {
    if (e.row && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.$router.push({
        path: `/measuringstates/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}`,
      });
    }
  }

  public async setSelectedMeasuringStatesQualityChecked() {
    if (!this.gridInstance.getSelectedRowsData().length) {
      return;
    }

    if (!confirm('Uitvoering van alle geselecteerde meetstaten gecontroleerd?')) {
      return;
    }

    this.loading = true;

    try {
      const measuringStates = this.gridInstance.getSelectedRowsData().map((ms) => ms.documentNumber);
      const command = new SetMultipleQualityCheckedCommand({
        documentNumbers: measuringStates,
        periodType: this.periodType,
      });

      await this.measuringStatesClient.setMultipleQualityChecked(command);
      await this.gridInstance.refresh();
      this.gridInstance.clearSelection();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  public onSelectionChanged(e: any) {
    this.executeBtnDisabled = !e?.selectedRowsData?.length;
  }

  async loadEmployees() {
    try {
      this.loading = true;
      this.employees = (await employeesRepository.get()).data;
      this.loading = false;
    } catch {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de medewerkers');
    }
  }

  get columns() {
    return [
      {
        dataField: 'projectNumber',
        caption: 'Projectnr.',
      },
      {
        dataField: 'projectName',
        caption: 'Projectnaam',
      },
      {
        dataField: 'customer',
        caption: 'Referentie (klant)',
      },
      {
        dataField: 'documentNumber',
        caption: 'Meetstaatnr.',
      },
      {
        dataField: 'name',
        caption: 'Titel',
      },
      {
        dataField: 'percentageExecuted',
        caption: '% uitgevoerd',
      },
      {
        dataField: 'projectLeader',
        caption: 'Projectleider',
        lookup: {
          dataSource: this.employeeSources,
        },
      },
      {
        dataField: 'qualityGuard',
        caption: 'Quality Guard',
        lookup: {
          dataSource: this.employeeSources,
        },
      },
      {
        dataField: 'subcontractor',
        caption: 'Onderaannemer',
      },
    ];
  }

  get gridInstance(): dxDataGrid {
    return (this.$refs.grid as any)?.$refs.measuringStatesFollowUpTable.instance as dxDataGrid;
  }

  get datasource() {
    const self = this;

    return new DataSource({
      store: new dxCustomStore({
        key: 'documentNumber',
        load: async (loadOptions) => {
          if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
            loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
          }

          loadOptions.requireTotalCount = true;

          const result = await this.measuringStatesClient.listForFollowUp(
            new ListForFollowUpQuery({
              billingType: self.billingType ?? undefined,
              periodType: self.periodType,
              options: DataSourceLoadOptionsBase.fromJS(loadOptions),
            })
          );

          this.totalCount = result.totalCount!;

          return {
            data: result.data,
            totalCount: result.totalCount,
          };
        },
      }),
      paginate: true,
    });
  }

  get employeeSources() {
    return this.employees.map((e) => e.displayName);
  }

  @Watch('billingType')
  @Watch('periodType')
  async onPropsChanged(newValue: any, oldValue: any) {
    await this.gridInstance.refresh();
  }
}
